// extracted by mini-css-extract-plugin
module.exports = {"contentGrid":"ViewProductPage_contentGrid__m3EqM"};